import {
  Header as CommonHeader,
  HeaderType,
} from '@foxtrotplatform/platform-micro-site-core';
import React from 'react';
import { useDispatch } from 'react-redux';

import { setApplications } from '../reducers/applicationSlice';
import { setInvitations } from '../reducers/invitationSlice';
import { setInvitees } from '../reducers/inviteeSlice';
import { setTeamMembers } from '../reducers/teamMemberSlice';

const WorkspaceLink: React.FunctionComponent = (): JSX.Element => {
  return (
    <div className="flex flex-row items-center">
      <a
        className="font-header mx-4 text-sm"
        href="https://docs.getos1.com"
        rel="noreferrer"
        target="_blank"
      >
        Docs
      </a>
    </div>
  );
};

export const Header = (): JSX.Element => {
  const dispatch = useDispatch();
  const clearReduxState = React.useCallback(() => {
    dispatch(setApplications([]));
    dispatch(setInvitations([]));
    dispatch(setInvitees([]));
    dispatch(setTeamMembers([]));
  }, [dispatch]);

  const onLogout = React.useCallback(() => {
    localStorage.clear();
    sessionStorage.clear();
    clearReduxState();
  }, [clearReduxState]);

  return (
    <div className="z-20">
      <CommonHeader
        customHeaderButton={<WorkspaceLink />}
        headerType={HeaderType.developer}
        onLogout={onLogout}
      />
    </div>
  );
};
